import {
  Accordion,
  AccordionItem,
  Group,
  NumberFormatter,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useMemo } from "react";
import ActivitySummary from "./summary/ActivitySummary";
import { useReportingStore } from "../../../../stores/ReportingStore";
import ActivitySummaryMulti from "./summary/ActivitySummaryMulti";
import ReportingInfo from "../ReportingInfo";
import { useLanguage } from "../../../../stores/LanguageStore";

const ReportingActivity = () => {
  const lang = useLanguage((s) => s.language);
  const programmations = useReportingStore((s) => s.programmations);
  const actualStatsDate = useReportingStore((s) => s.actualStatsDate);

  const statistics = useMemo(() => {
    const totals = actualStatsDate.reduce((acc, curr) => {
      Object.keys(curr).forEach((key) => {
        if (key !== "date") {
          acc[key] = (acc[key] || 0) + curr[key];
        }
      });
      return acc;
    }, {});
    return totals;
  }, [actualStatsDate]);

  const component = useMemo(() => {
    if (programmations.length > 1) {
      return <ActivitySummaryMulti />;
    }
    return <ActivitySummary />;
  }, [programmations.length]);

  return (
    <Accordion variant="contained" radius={"md"} defaultValue={"activity"}>
      <AccordionItem value="activity" style={{ border: 0 }}>
        <Accordion.Control bg={"primary.0"}>
          <Group pr={32}>
            <Title order={3} fw={500} ff={"Inter"} mb={8} pos={"relative"}>
              <span style={{ fontSize: 24, marginRight: 8 }}>📊</span>{" "}
              {lang.reports.global_activity}
            </Title>

            <ReportingInfo>
              <Text>{lang.reports.global_activity_text}</Text>
            </ReportingInfo>

            <Text ml={"auto"} size="lg">
              <NumberFormatter
                value={statistics.email_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.email_sent}{" "}
              <NumberFormatter
                value={statistics.linkedin_sent}
                style={{ fontWeight: 700 }}
              />{" "}
              {lang.reports.linkedin_actions}
            </Text>
          </Group>
        </Accordion.Control>

        <Accordion.Panel bg={"var(--mantine-color-primary-2)"}>
          <Stack align="center" pt={16}>
            {component}
          </Stack>
        </Accordion.Panel>
      </AccordionItem>
    </Accordion>
  );
};

export default ReportingActivity;
